import axios from 'axios'

type ContactUsFormData = {
	name: string
	email: string
	subject?: string
	message: string
	'g-recaptcha-response': string
}

export default async function contactUs(data: ContactUsFormData) {
	try {
		const response = await axios.post(
			process.env.NEXT_PUBLIC_BACKEND_URL + '/hotels/contact-us',
			JSON.stringify(data),
			{
				headers: {
					'Content-Type': 'application/json',
				},
			}
		)

		return response.data
	} catch (error) {
		console.error('Contact:err', error)
		throw error
	}
}
